class PlatformSelector {
  static start() {
    $(document).on("click", "[data-platform-url]", function() {
      location.href = $(this).data("platform-url")
    })
  }
}

export default PlatformSelector
